import React, { useContext } from 'react';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';
import { Button } from '@riac/design-system';
import { ISearchInput } from 'src/pages/CatalogPage/CatalogPage.i';

export interface IClearFiltersProps {
  searchInput: ISearchInput;
}

export const ClearFilters = ({ searchInput }:IClearFiltersProps) => {
  const { auctionId, gotoAddress } = useContext(CatalogContext);
  const address = `/catalog/${auctionId}/`;
  const ignoreKeys = ['pageNumber', 'perPage', 'sortBy'];
  let hasFilters = false;

  for(const key in searchInput) {
    if(ignoreKeys.indexOf(key) >= 0) {
      continue;
    }
    if(searchInput.hasOwnProperty(key) && searchInput[key]) {
      hasFilters = true;
    }
  }
  if(!hasFilters) return null;

  return (
    <Button unstyled className='text-md font-bold tracking-wide leading-6 text-error hover:text-error-hover active:text-error-active p-0' onPress={() => {
      gotoAddress(address);
    }}>
      Remove Filters
    </Button>
  );
};
